import type { ReactNode } from "react";

import { Flex } from "@radix-ui/themes";

import "./overview.css";

export interface OverviewPresentationProps {
  account: ReactNode;
  cash: ReactNode;
  balances: ReactNode;
  indices: ReactNode;
  activity: ReactNode;
}

/** Overview CSS grid shell — cards arrive as props so layout stays provider-free. */
export const OverviewPresentation = ({
  account,
  cash,
  balances,
  indices,
  activity,
}: OverviewPresentationProps) => (
  <Flex
    direction="column"
    data-testid="overview-panel"
    className="h-full min-h-0 w-full overflow-auto"
  >
    <div className="overview-primary-grid">
      <Flex minWidth="0" align="stretch" className="overview-account">
        {account}
      </Flex>
      <Flex minWidth="0" align="stretch" className="overview-cash">
        {cash}
      </Flex>
      <Flex minWidth="0" align="stretch" className="overview-balances">
        {balances}
      </Flex>
      <Flex minWidth="0" align="stretch" className="overview-indices">
        {indices}
      </Flex>
      <Flex minWidth="0" align="stretch" className="overview-activity">
        {activity}
      </Flex>
    </div>
  </Flex>
);
